export const PremiumIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="btn-premium-icon"
  >
    <path d="M2 19h20v2H2v-2zM2 5l3.5 4.5L12 3l6.5 6.5L22 5v12H2V5z" />
  </svg>
);
